module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "facing-type-card-exchange-select"
  }, [(_vm.isAuthenticated) ? [_c('app-header', {
    attrs: {
      "hide-shadow": "hide-shadow"
    }
  }), _c('es-my-card-sub-menu')] : [_c('app-header-noauth')], _vm._m(0), _c('div', {
    staticClass: "facing-type-card-exchange-select__main",
    class: {
      '-no-auth': !_vm.isAuthenticated
    }
  }, [_c('p', {
    staticClass: "facing-type-card-exchange-select__main--title"
  }, [_vm._v("あなたはこのESmyカードを…")]), _c('div', {
    staticClass: "facing-type-card-exchange-select__main--buttons"
  }, [_c('button', {
    staticClass: "main-buttons__button",
    on: {
      "click": _vm.getCard
    }
  }, [_vm._v("もらった")]), _c('button', {
    staticClass: "main-buttons__button",
    on: {
      "click": _vm.giveCard
    }
  }, [_vm._v("渡す")])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "facing-type-card-exchange-select__header"
  }, [_c('h2', {
    staticClass: "facing-type-card-exchange-select__header--title"
  }, [_vm._v("手書きでもらった・渡したカードは、"), _c('br'), _vm._v("写真で撮ってUPしてねだニャン♪")]), _c('div', {
    staticClass: "facing-type-card-exchange-select__header--content"
  }, [_c('p', {
    staticClass: "header-content__text"
  }, [_vm._v("相手が既にUPしてたら、"), _c('br'), _vm._v("重複UPは不要だニャン♪")]), _c('div', {
    staticClass: "header-content__cartoon"
  }, [_c('img', {
    staticClass: "header-content__cartoon--image",
    attrs: {
      "src": require("../images/img_cat_thanks.png"),
      "alt": "ありがとにゃん"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8dbfdec0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/facingtype-card-exchange-select.pug
// module id = 1430
// module chunks = 1